import { useEffect, useState } from 'react'

import { FloatingLoader } from '~/@common/ui/(Loader)/FloatingLoader'

const SHOW_DELAY_MS = 200

/**
 * 라우트 청크를 받는 동안의 Suspense fallback. 빠른 망에서는 청크가 수십 ms 에 오므로 즉시 로더를 띄우면
 * 깜빡임만 남는다 — 지연 뒤에만 보여 느린 망에서만 피드백이 생긴다.
 */
export const RouteLoadingFallback = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS)
    return () => clearTimeout(timer)
  }, [])

  if (!visible) return null

  // FloatingLoader 는 absolute 라 기준 요소가 없으면 뷰포트 전체(GNB 포함)를 덮는다. 본문 영역으로 가둔다.
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <FloatingLoader />
    </div>
  )
}
